import { BaseService } from 'src/app/core/services/base.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RightSidebarService {
  constructor(private base: BaseService) {}

  getGroups() {
    return this.base.get('');
  }

  getSuggested() {
    return this.base.get('suggested');
  }

  // /api/suggested?token=1_e7754d01f4ed8abb0883fae18ffe7a44
}
